import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/use-auth';
import { LoadingScreen } from '../loading/LoadingScreen';

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return <LoadingScreen />;
  }

  if (!user) {
    return <Navigate to="/signin" replace />;
  }

  return children;
}
